import React from 'react';
import { AlertTriangle } from 'lucide-react';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

// Umgebungs-Banner (z. B. QS-Stage): erscheint nur, wenn zur Build-Zeit
// REACT_APP_STAGE_BANNER gesetzt ist (Host-.env → docker-compose Build-Arg,
// siehe README „Umgebungsvariablen"). Der Wert ist der angezeigte Text.
// Auf Produktion bleibt die Variable leer → kein Banner, keine Höhe.
export const STAGE_BANNER_TEXT = (process.env.REACT_APP_STAGE_BANNER || '').trim();
export const STAGE_BANNER_HEIGHT = STAGE_BANNER_TEXT ? 36 : 0;

// Fixe Leiste über der gesamten App (auch Login/Pricing), damit auf einen Blick
// erkennbar ist, dass man nicht auf Produktion arbeitet. Der Spacer schiebt den
// normalen Seiteninhalt nach unten; fixed positionierte Elemente (Sidebar in
// Layout.js) müssen STAGE_BANNER_HEIGHT selbst als top-Offset berücksichtigen.
const StageBanner = () => {
  if (!STAGE_BANNER_TEXT) return null;

  return (
    <>
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        height: STAGE_BANNER_HEIGHT, zIndex: 300,
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        padding: '0 12px', boxSizing: 'border-box',
        background: 'var(--warn-100)',
        borderBottom: '1px solid var(--warn-500)',
        color: 'var(--warn-700)',
        fontFamily: FONT, fontSize: 13, fontWeight: 600,
        whiteSpace: 'nowrap', overflow: 'hidden',
      }}>
        <AlertTriangle width={15} height={15} style={{ flexShrink: 0 }} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{STAGE_BANNER_TEXT}</span>
      </div>
      <div style={{ height: STAGE_BANNER_HEIGHT, flexShrink: 0 }} />
    </>
  );
};

export default StageBanner;
